export default [
  {
    path: "/labRegister", // 入驻实验室
    name: "labRegister",
    component: () =>
      import(
        /* webpackChunkName: "lab" */ "../views/Laboratory/LabRegister/index.vue"
      ),
    meta: {
      eventId: "W-LB-23-V1",
      eventName: "实验室入驻曝光",
      module: "成员专区",
    },
  },

  {
    path: "/labList", // 实验室列表
    name: "labList",
    component: () =>
      import(
        /* webpackChunkName: "lab" */ "../views/Laboratory/LabList/index.vue"
      ),
    meta: {
      eventId: "W-LB-21-V1",
      eventName: "实验室列表曝光",
      module: "成员专区",
    },
  },
  {
    path: "/labDetail", // 实验室详情
    name: "labDetail",
    component: () =>
      import(
        /* webpackChunkName: "lab" */ "../views/Laboratory/LabDetail/index.vue"
      ),
    meta: {
      eventId: "W-LB-22-V1",
      eventName: "实验室详情曝光",
      module: "成员专区",
    },
  },
  {
    path: "/labNearby", // 附近的实验室
    name: "labNearby",
    component: () =>
      import(
        /* webpackChunkName: "lab" */ "../views/Laboratory/LabNearby/index.vue"
      ),
    meta: {
      eventId: "W-LB-24-V1",
      eventName: "附近的实验室曝光",
      module: "成员专区",
    },
  },
];
